import { useNavigate, useLocation } from "react-router-dom";
import React, { useState } from "react";
import { Form,  Button, Typography, Flex, Alert } from "antd";
import FormInput from "../../../shared/components/form/formInput/FormInput";
import hff_donors_logo_dark from "./../../../assets/images/hff_donors_logo_dark.png"
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { AUTH_SERVICE } from '../../../shared/services/auth-service';
import "./ResetPassword.scss"

const { Title, Text } = Typography;



const ResetPassword: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<'success' | 'error' | null>(null);

    const handleReset = async (values: { password: string }) => {
        const token = new URLSearchParams(location.search).get('token');
        const email = new URLSearchParams(location.search).get('email');
        

        if (!token || !email) {
            setStatus('error');
            return;
        }

        setLoading(true);
        setStatus(null);

        try {
            const response = await AUTH_SERVICE.resetPassword('/api/crm/reset-password', {
                token,
                email: decodeURIComponent(email),
                password: values.password
            });
            
            if (response?.success) {
                setStatus('success');
                form.resetFields();
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            }
        } catch (error) {
            setStatus('error');
        } finally {
            setLoading(false);
        }
    };

    const passwordRules = [
        { required: true, message: "Please input your new password!" },
        {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[=@$!%*?&\]"[\-^])[A-Za-z\d=@$!%*?&\]"[\-^]{8,}$/,
            message: (
                <Flex gap={12} vertical>
                    <Text color="red" className="reset-pwd-instructions">Must be at least 8 characters long.</Text>
                    <Text color="red" className="reset-pwd-instructions">Must contain both uppercase and lowercase letters.</Text>
                    <Text color="red" className="reset-pwd-instructions">Must contain a number.</Text>
                    <Text color="red" className="reset-pwd-instructions">Must contain at least one special character.</Text>
                </Flex>
            ),
        },
    ];

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f0f2f5",
            }}
            className="login-page"
        >
            <Flex vertical
                className="box-shadow-thin"
                style={{
                    width: 500,
                    padding: 30,
                    backgroundColor: "#fff",
                    margin: "10px"
                }}
            >
                <Flex justify="center" align="center" vertical>
                    <img
                        src={hff_donors_logo_dark}
                        alt="HFF Donors"
                        width={265}
                    />
                    <Title level={3} className="p-10" style={{ textAlign: "center", marginBottom: 20 }}>
                        Reset Password
                    </Title>
                </Flex>
                <Form name="loginForm" layout="vertical" onFinish={handleReset} requiredMark={false} form={form}>
                    <Flex vertical gap={32}>
                    
                            <Text style={{ fontWeight: "500" }}>Enter a new password to reset the password on your account.</Text>
                            <FormInput
                                label="New Password"
                                name="password"
                                type="password"
                                className="input-height mb-10"
                                rules={passwordRules}
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}

                            />
                        

                        {status === 'success' && (
                            <Alert
                                message="Password reset successful"
                                description="Redirecting to login page..."
                                type="success"
                                showIcon
                                style={{ marginBottom: 16 }}
                            />
                        )}
                        {status === 'error' && (
                            <Alert
                                message="Failed to reset password. Please try again."
                                type="error"
                                showIcon
                                style={{ marginBottom: 16 }}
                            />
                        )}
                        <Form.Item>
                            <Button
                                className="input-height"
                                type="primary"
                                htmlType="submit"
                                block
                            >
                                Reset Password
                            </Button>
                        </Form.Item>
                    </Flex>
                </Form>
            </Flex>
        </div>
    );
};

export default ResetPassword;
